import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neutron-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
